/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadServiceResourceRegion {
    getFixupPrototypeFunction() { return WorkloadServiceResourceRegion.fixupPrototype; }

    static newInstance(model: Partial<WorkloadServiceResourceRegion>): WorkloadServiceResourceRegion {
        let obj = Object.assign(new WorkloadServiceResourceRegion(), model);
        WorkloadServiceResourceRegion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadServiceResourceRegion>): WorkloadServiceResourceRegion {
        if (!model) return null;
        return WorkloadServiceResourceRegion.newInstance(<WorkloadServiceResourceRegion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadServiceResourceRegion) {
        if (!obj) return;

        models.WorkloadServiceResourceRegion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadServiceResourceRegion): boolean {
        Object.setPrototypeOf(obj, WorkloadServiceResourceRegion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Resource Region
     */
    region: string;

}
